const saveDiscipline = async (payload) => {
  try {
    return await axios.post('/discipline', payload)
  }
  catch (e) {
    throw e
  }
}

const saveSubdiscipline = async (payload) => {
  try {
    return await axios.post('/subdiscipline', payload)
  }
  catch (e) {
    throw e
  }
}

const deleteSubdiscipline = async(payload) => {
  const { subdiscipline } = payload
  console.log(subdiscipline.id)
  try {
      return await axios.delete(`subdiscipline/${subdiscipline.id}`)
  } catch(e) {
      throw e
  }
}

const deleteDiscipline = async(payload) => {
  const { discipline } = payload
  console.log(discipline.id)
  try {
      return await axios.delete(`discipline/${discipline.id}`)
  } catch(e) {
      throw e
  }
}

export {
  saveDiscipline,
  saveSubdiscipline,
  deleteSubdiscipline,
  deleteDiscipline,
}
